module.exports = __webpack_public_path__ + "img/productionBase_1.fe23aac1.png";